﻿(function () {
    function clog(step, info) {
      try {
        if (info === undefined) {
          console.log('[catalog]', step);
        } else {
          console.log('[catalog]', step, info);
        }
      } catch (error) {}
    }

    function elInfo(el) {
      if (!el || !el.tagName) return null;
      return {
        tag: el.tagName,
        id: el.id || '',
        className: String(el.className || '').slice(0, 80),
        attrs: {
          handle: el.getAttribute && el.getAttribute('data-handle'),
          optionName: el.getAttribute && el.getAttribute('data-option-name'),
          catalogClose: el.hasAttribute && el.hasAttribute('data-catalog-close'),
          catalogView: el.getAttribute && el.getAttribute('data-catalog-view'),
          catalogAtc: el.hasAttribute && el.hasAttribute('data-catalog-atc'),
        },
      };
    }

    function readJSONNode(el, fallback) {
      if (!el) return fallback;
      try {
        var raw = ((el.value || '') + '').trim();
        if (!raw) raw = (el.textContent || '').trim();
        if (!raw) return fallback;
        return JSON.parse(raw);
      } catch (error) {
        clog('readJSONNode:parse-fail', { id: el.id || '', error: String(error) });
        return fallback;
      }
    }

    function parseJSON(id, fallback) {
      return readJSONNode(document.getElementById(id), fallback);
    }

    function getRoot() {
      return document.querySelector('[data-catalog-root]');
    }

    function getProducts() {
      var root = getRoot();
      if (root && root._catalogProducts) return root._catalogProducts;
      var data = parseJSON('CatalogProductsData', {});
      if (root && data && Object.keys(data).length) root._catalogProducts = data;
      return data;
    }

    function getStrings() {
      return parseJSON('CatalogStrings', {});
    }

    function productFromRow(row) {
      if (!row) return null;
      var handle = row.getAttribute('data-handle');
      var products = getProducts();
      if (handle && products[handle]) return products[handle];
      var local = readJSONNode(row.querySelector('[data-catalog-item-json]'), null);
      if (local && handle) {
        products[handle] = local;
        var root = getRoot();
        if (root) root._catalogProducts = products;
      }
      return local || null;
    }

    function getPanel(root) {
      if (!root) return null;
      if (!root._catalogPanel) {
        root._catalogPanel = new CatalogPanel(root);
        root.dataset.catalogBound = 'true';
      } else {
        root._catalogPanel.refresh();
      }
      return root._catalogPanel;
    }

    function fromProductJs(p) {
      var names = (p.options || []).map(function (opt) {
        return typeof opt === 'string' ? opt : opt.name;
      });
      var values = {};
      names.forEach(function (name) {
        values[name] = [];
      });
      (p.variants || []).forEach(function (variant) {
        names.forEach(function (name, index) {
          var val = variant['option' + (index + 1)];
          if (val && values[name].indexOf(val) === -1) values[name].push(val);
        });
      });
      var image = p.featured_image;
      if (image && typeof image === 'object') image = image.src || '';
      return {
        id: p.id,
        handle: p.handle,
        title: p.title,
        image: image || '',
        available: p.available,
        price: p.price,
        options: names.map(function (name) {
          return { name: name, values: values[name] };
        }),
        variants: (p.variants || []).map(function (variant) {
          var vimg = variant.featured_image;
          if (vimg && typeof vimg === 'object') vimg = vimg.src || '';
          return {
            id: variant.id,
            sku: variant.sku,
            available: variant.available,
            price: variant.price,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            image: vimg || image || '',
          };
        }),
        recs: [],
      };
    }

    function showProduct(root, row, product) {
      var panel = getPanel(root);
      clog('showProduct', {
        hasPanel: !!panel,
        hasProduct: !!product,
        productId: product && product.id,
        handle: row && row.getAttribute('data-handle'),
        panelNode: panel && elInfo(panel.panel),
        content: !!(panel && panel.content),
      });
      if (!panel || !product) {
        clog('showProduct:abort', { hasPanel: !!panel, hasProduct: !!product });
        return;
      }
      root.querySelectorAll('[data-catalog-row].is-selected').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      var handle = row.getAttribute('data-handle');
      if (handle) {
        root.querySelectorAll('[data-catalog-row][data-handle="' + handle + '"]').forEach(function (item) {
          item.classList.add('is-selected');
        });
      }
      panel.setProduct(product, mergeRecs(product, product.recs || []));
      loadRecs(root, product, function (recs) {
        if (panel.product && panel.product.id === product.id) {
          panel.recs = recs;
          panel.renderRecs();
        }
      });
    }

    function openCatalogRow(root, row) {
      clog('openCatalogRow:enter', {
        hasRoot: !!root,
        hasRow: !!row,
        handle: row && row.getAttribute('data-handle'),
        rowConnected: !!(row && row.isConnected),
      });
      if (!root || !row) return;
      var product = productFromRow(row);
      clog('openCatalogRow:product', {
        found: !!product,
        id: product && product.id,
        title: product && product.title,
        options: product && product.options && product.options.length,
        variants: product && product.variants && product.variants.length,
      });
      if (product) {
        showProduct(root, row, product);
        return;
      }
      var handle = row.getAttribute('data-handle');
      if (!handle) {
        clog('openCatalogRow:no-handle');
        return;
      }
      var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = rootPath + 'products/' + encodeURIComponent(handle) + '.js';
      clog('openCatalogRow:fetch', url);
      fetch(url)
        .then(function (res) {
          clog('openCatalogRow:fetch-status', res.status);
          return res.json();
        })
        .then(function (data) {
          var normalized = fromProductJs(data);
          var products = getProducts();
          products[handle] = normalized;
          root._catalogProducts = products;
          showProduct(root, row, normalized);
        })
        .catch(function (error) {
          clog('openCatalogRow:fetch-fail', String(error));
        });
    }

    function getDefaultRecs() {
      var recs = parseJSON('CatalogDefaultRecs', []);
      return Array.isArray(recs) ? recs : [];
    }

    function cartAddUrl() {
      return (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add.js';
    }

    function cartUrl() {
      return (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart.js';
    }

    function cartReadConfig() {
      if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.fetchConfig === 'function') {
        return FoxTheme.utils.fetchConfig();
      }
      return { method: 'GET', headers: { Accept: 'application/json' } };
    }

    function addToCart(items, button) {
      clog('addToCart:start', items);
      if (!items || !items.length) {
        clog('addToCart:empty');
        return Promise.resolve();
      }
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
      }

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      var headers = { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
      if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.fetchConfig === 'function') {
        headers = FoxTheme.utils.fetchConfig('javascript').headers || headers;
        headers['X-Requested-With'] = 'XMLHttpRequest';
      }

      return fetch(cartAddUrl(), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            clog('addToCart:add-response', {
              http: res.status,
              ok: res.ok,
              keys: data && Object.keys(data),
              status: data && data.status,
              message: data && data.message,
              description: data && data.description,
              hasSections: !!(data && data.sections),
            });
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || 'Error');
          }
          return fetch(cartUrl(), cartReadConfig()).then(function (res) {
            var type = (res.headers.get('content-type') || '').toLowerCase();
            if (type.indexOf('json') === -1) {
              clog('addToCart:cart-not-json', { type: type, url: cartUrl() });
              return fetch('/cart.js').then(function (r) {
                return r.json();
              });
            }
            return res.json();
          }).then(function (cart) {
            if (result.data.sections) cart.sections = result.data.sections;
            clog('addToCart:cart', { item_count: cart.item_count, hasSections: !!cart.sections });
            return cart;
          });
        })
        .then(function (cart) {
          if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function' && (!window.FoxTheme || FoxTheme.settings.cartType !== 'page')) {
            drawer.show();
          }
          clog('addToCart:done');
        })
        .catch(function (error) {
          clog('addToCart:fail', { error: String(error), stack: error && error.stack });
          throw error;
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
        });
    }

    function findVariant(product, selected) {
      if (!product || !product.variants) return null;
      return product.variants.find(function (variant) {
        return (product.options || []).every(function (option, index) {
          return variant['option' + (index + 1)] === selected[option.name];
        });
      }) || product.variants[0];
    }

    function isValueAvailable(product, optionIndex, value, selected) {
      return (product.variants || []).some(function (variant) {
        if (variant['option' + (optionIndex + 1)] !== value) return false;
        return (product.options || []).every(function (option, index) {
          if (index === optionIndex) return true;
          return variant['option' + (index + 1)] === selected[option.name];
        });
      });
    }

    function stockLabel(variant, strings) {
      if (!variant || !variant.available) return strings.outOfStock || strings.soldOut;
      return strings.inStock;
    }

    function CatalogPanel(root) {
      this.root = root;
      this.product = null;
      this.selected = {};
      this.variant = null;
      this.recs = [];
      this.manual = false;
      this.refresh();
    }

    CatalogPanel.prototype.refresh = function () {
      var root = this.root;
      this.panel = root.querySelector('[data-catalog-panel]');
      this.empty = root.querySelector('[data-panel-empty]');
      this.content = root.querySelector('[data-panel-content]');
      this.image = root.querySelector('[data-panel-image]');
      this.title = root.querySelector('[data-panel-title]');
      this.sku = root.querySelector('[data-panel-sku]');
      this.options = root.querySelector('[data-panel-options]');
      this.qty = root.querySelector('[data-panel-qty]');
      this.stock = root.querySelector('[data-panel-stock]');
      this.price = root.querySelector('[data-panel-price]');
      this.atc = root.querySelector('[data-panel-atc]');
      this.recsWrap = root.querySelector('[data-panel-recs-wrap]');
      this.recsList = root.querySelector('[data-panel-recs]');
      this.total = root.querySelector('[data-panel-total]');
    };

    CatalogPanel.prototype.open = function () {
      this.root.classList.add('catalog--panel-open');
      if (this.panel) this.panel.setAttribute('aria-hidden', 'false');
      if (this.empty) this.empty.hidden = true;
      if (this.content) this.content.hidden = false;
      var cs = this.panel ? window.getComputedStyle(this.panel) : null;
      clog('panel.open', {
        classOpen: this.root.classList.contains('catalog--panel-open'),
        hasPanel: !!this.panel,
        hasContent: !!this.content,
        contentHidden: this.content ? this.content.hidden : null,
        width: cs && cs.width,
        maxWidth: cs && cs.maxWidth,
        visibility: cs && cs.visibility,
        pointerEvents: cs && cs.pointerEvents,
      });
    };

    CatalogPanel.prototype.close = function () {
      clog('panel.close', { stack: (new Error().stack || '').split('\n').slice(0, 6).join(' | ') });
      this.root.classList.remove('catalog--panel-open');
      if (this.panel) this.panel.setAttribute('aria-hidden', 'true');
      var backdrop = this.root.querySelector('.catalog-backdrop');
      if (backdrop) backdrop.remove();
      this.root.querySelectorAll('[data-catalog-row].is-selected').forEach(function (row) {
        row.classList.remove('is-selected');
      });
      if (this.empty) this.empty.hidden = true;
      if (this.content) this.content.hidden = true;
    };

    CatalogPanel.prototype.setProduct = function (product, recs) {
      try {
        this.refresh();
        clog('setProduct', {
          title: product && product.title,
          panel: !!this.panel,
          content: !!this.content,
          options: !!this.options,
          recsList: !!this.recsList,
          total: !!this.total,
          qty: !!this.qty,
        });
        this.product = product;
        this.recs = recs || [];
        this.manual = false;
        this.selected = {};
        var first = (product.variants || []).find(function (variant) {
          return variant.available;
        }) || (product.variants || [])[0];
        (product.options || []).forEach(function (option, index) {
          this.selected[option.name] = first ? first['option' + (index + 1)] : option.values[0];
        }, this);
        if (this.qty) this.qty.value = 1;
        this.render();
        this.open();
      } catch (error) {
        clog('setProduct:THREW', { error: String(error), stack: error && error.stack });
        console.error('[catalog] setProduct threw', error);
        this.open();
      }
    };

    CatalogPanel.prototype.render = function () {
      if (!this.product || !this.content) {
        clog('render:abort', { hasProduct: !!this.product, hasContent: !!this.content });
        return;
      }
      this.variant = findVariant(this.product, this.selected);
      var strings = getStrings();
      var image = (this.variant && this.variant.image) || this.product.image || '';
      if (this.image) {
        this.image.src = image;
        this.image.alt = this.product.title || '';
        this.image.hidden = !image;
      }
      if (this.title) this.title.textContent = this.product.title || '';
      if (this.sku) this.sku.textContent = this.variant && this.variant.sku ? this.variant.sku : '';
      if (this.price) this.price.textContent = this.variant ? this.variant.price : this.product.price || '';
      if (this.stock) {
        this.stock.className = 'catalog-stock ' + (this.variant && this.variant.available ? 'catalog-stock--in' : 'catalog-stock--out');
        this.stock.innerHTML = '<span class="catalog-stock__dot"></span>' + stockLabel(this.variant, strings);
      }
      if (this.atc) this.atc.disabled = !(this.variant && this.variant.available);
      this.renderOptions();
      this.renderRecs();
    };

    CatalogPanel.prototype.renderOptions = function () {
      if (!this.options) return;
      var product = this.product;
      var selected = this.selected;
      var html = '';
      (product.options || []).forEach(function (option, optionIndex) {
        html += '<div class="catalog-option"><span class="catalog-option__label">' + option.name + '</span><div class="catalog-option__chips">';
        option.values.forEach(function (value) {
          var available = isValueAvailable(product, optionIndex, value, selected);
          var classes = 'catalog-chip';
          if (selected[option.name] === value) classes += ' is-selected';
          if (!available) classes += ' is-unavailable';
          html +=
            '<button type="button" class="' +
            classes +
            '" data-option-name="' +
            option.name.replace(/"/g, '&quot;') +
            '" data-option-value="' +
            String(value).replace(/"/g, '&quot;') +
            '"' +
            (available ? '' : ' disabled') +
            '>' +
            value +
            '</button>';
        });
        html += '</div></div>';
      });
      this.options.innerHTML = html;
    };

    CatalogPanel.prototype.renderRecs = function () {
      if (!this.recsWrap || !this.recsList) return;
      var recs = (this.recs || []).slice(0, 3);
      this.recs = recs;
      if (!recs.length) {
        this.recsWrap.hidden = true;
        this.updateTotal();
        return;
      }
      this.recsWrap.hidden = false;
      this.recsList.innerHTML = recs
        .map(function (rec, index) {
          var checked = this.manual ? '' : ' checked';
          var img = rec.image
            ? '<img class="catalog-rec__img" src="' + rec.image + '" alt="" width="44" height="44">'
            : '<span class="catalog-rec__img"></span>';
          var meta = [rec.material, rec.sku, rec.price].filter(Boolean).join(' · ');
          return (
            '<div class="catalog-rec" data-rec-index="' +
            index +
            '">' +
            img +
            '<div><span class="catalog-rec__title">' +
            rec.title +
            '</span><span class="catalog-rec__meta">' +
            meta +
            '</span></div>' +
            '<div class="catalog-rec__tools">' +
            '<div class="catalog-stepper"><button type="button" class="catalog-stepper__btn" data-rec-minus>&minus;</button>' +
            '<input class="catalog-stepper__input" data-rec-qty type="number" min="1" value="1">' +
            '<button type="button" class="catalog-stepper__btn" data-rec-plus>+</button></div>' +
            '<input type="checkbox" class="checkbox" data-rec-check' +
            checked +
            (rec.available ? '' : ' disabled') +
            '>' +
            '</div></div>'
          );
        }, this)
        .join('');
      this.updateTotal();
    };

    CatalogPanel.prototype.updateTotal = function () {
      if (!this.recsList || !this.total) {
        clog('updateTotal:abort', { recsList: !!this.recsList, total: !!this.total });
        return;
      }
      var strings = getStrings();
      var count = 1;
      this.recsList.querySelectorAll('[data-rec-check]:checked').forEach(function () {
        count += 1;
      });
      this.total.textContent = (strings.total || 'Total') + ' (' + count + ' ' + (strings.items || 'items') + ')';
    };

    CatalogPanel.prototype.currentItems = function (includeRecs) {
      var items = [];
      if (this.variant && this.variant.available) {
        items.push({ id: this.variant.id, quantity: parseInt(this.qty && this.qty.value, 10) || 1 });
      }
      if (includeRecs) {
        this.recsList.querySelectorAll('.catalog-rec').forEach(function (row) {
          var check = row.querySelector('[data-rec-check]');
          if (!check || !check.checked) return;
          var rec = this.recs[parseInt(row.getAttribute('data-rec-index'), 10)];
          if (!rec || !rec.variant_id || !rec.available) return;
          items.push({
            id: rec.variant_id,
            quantity: parseInt(row.querySelector('[data-rec-qty]').value, 10) || 1,
          });
        }, this);
      }
      return items;
    };

    function setView(root, view) {
      root.removeAttribute('data-catalog-view');
      root.setAttribute('data-catalog-current-view', view);
      var table = root.querySelector('[data-catalog-table]');
      var grid = root.querySelector('[data-catalog-grid]');
      if (table) table.hidden = view !== 'table';
      if (grid) grid.hidden = view !== 'grid';
      root.querySelectorAll('button[data-catalog-view]').forEach(function (btn) {
        var active = btn.getAttribute('data-catalog-view') === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function exportList(root) {
      var products = getProducts();
      var lines = [['Title', 'SKU', 'Material', 'Price', 'Available']];
      root.querySelectorAll('[data-catalog-table] [data-catalog-row]').forEach(function (row) {
        if (row.hidden) return;
        var product = products[row.getAttribute('data-handle')];
        if (!product) return;
        var variant = product.variants && product.variants[0];
        lines.push([
          product.title,
          (variant && variant.sku) || '',
          product.material || '',
          (variant && variant.price) || product.price || '',
          variant && variant.available ? 'yes' : 'no',
        ]);
      });
      var csv = lines
        .map(function (line) {
          return line
            .map(function (value) {
              return '"' + String(value).replace(/"/g, '""') + '"';
            })
            .join(',');
        })
        .join('\n');
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'catalog.csv';
      link.click();
      URL.revokeObjectURL(link.href);
    }

    function productToRec(product) {
      var variant = product.variants && product.variants[0];
      return {
        id: product.id,
        handle: product.handle,
        title: product.title,
        material: product.material,
        image: product.image,
        available: product.available,
        variant_id: variant && variant.id,
        sku: variant && variant.sku,
        price: product.price,
      };
    }

    function mergeRecs(product, recs) {
      var seen = {};
      var list = [];
      function push(rec) {
        if (!rec || rec.id === product.id || seen[rec.id] || list.length >= 3) return;
        seen[rec.id] = true;
        list.push(rec);
      }
      (recs || []).forEach(push);
      getDefaultRecs().forEach(push);
      if (list.length < 3) {
        var products = getProducts();
        Object.keys(products).forEach(function (handle) {
          push(productToRec(products[handle]));
        });
      }
      return list;
    }

    function loadRecs(root, product, done) {
      if (product.recs && product.recs.length) {
        done(mergeRecs(product, product.recs));
        return;
      }
      var url = root.getAttribute('data-recommendations-url');
      if (!url) {
        done(mergeRecs(product, []));
        return;
      }
      fetch(url + product.id)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var payload = doc.querySelector('#CatalogRecsPayload script');
          var recs = [];
          if (payload) {
            try {
              recs = JSON.parse(payload.textContent);
            } catch (error) {
              recs = [];
            }
          }
          product.recs = recs;
          done(mergeRecs(product, recs));
        })
        .catch(function () {
          done(mergeRecs(product, []));
        });
    }

    function storeProductsFromHtml(html) {
      var root = getRoot();
      if (!root || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var data = readJSONNode(doc.getElementById('CatalogProductsData'), null);
      if (data && typeof data === 'object') root._catalogProducts = data;
    }

    function resetGridStyles() {
      var container = document.getElementById('ProductGridContainer');
      if (!container) return;
      container.style.opacity = '';
      container.style.transform = '';
      container.style.visibility = '';
      container.style.pointerEvents = '';
    }

    function bind(root) {
      if (!root) return;
      if (root.dataset.catalogBound === 'true' && root._catalogPanel) {
        clog('bind:already-bound-refresh');
        root._catalogPanel.refresh();
        return;
      }
      clog('bind:new');
      root.dataset.catalogBound = 'true';
      var panel = new CatalogPanel(root);
      root._catalogPanel = panel;

      function openRow(row) {
        openCatalogRow(root, row);
      }

      root.addEventListener('click', function (event) {
        var close = event.target.closest('[data-catalog-close]');
        if (close) {
          clog('root-click:close');
          panel.close();
          return;
        }

        var viewBtn = event.target.closest('button[data-catalog-view]');
        if (viewBtn) {
          clog('root-click:view', viewBtn.getAttribute('data-catalog-view'));
          setView(root, viewBtn.getAttribute('data-catalog-view'));
          return;
        }

        var exportBtn = event.target.closest('[data-catalog-export]');
        if (exportBtn) {
          clog('root-click:export');
          exportList(root);
          return;
        }

        var atc = event.target.closest('[data-catalog-atc]');
        if (atc) {
          clog('root-click:atc', elInfo(atc));
          var atcRow = atc.closest('[data-catalog-row]');
          if (atcRow && root.contains(atcRow)) {
            event.preventDefault();
            event.stopPropagation();
            openRow(atcRow);
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          var variantId = parseInt(atc.getAttribute('data-variant-id'), 10);
          if (!variantId) return;
          var original = atc.querySelector('span');
          addToCart([{ id: variantId, quantity: 1 }], atc)
            .then(function () {
              if (!original) return;
              var strings = getStrings();
              var prev = original.textContent;
              original.textContent = strings.added || 'Added';
              setTimeout(function () {
                original.textContent = prev;
              }, 1600);
            })
            .catch(function () {
              alert(getStrings().error || 'Error');
            });
          return;
        }

        if (event.target.closest('[data-catalog-product-link]')) {
          clog('root-click:product-link');
          return;
        }

        var select = event.target.closest('[data-catalog-select], [data-catalog-row]');
        if (select) {
          var row = select.closest('[data-catalog-row]');
          clog('root-click:row', { handle: row && row.getAttribute('data-handle') });
          if (!row) return;
          openRow(row);
        } else {
          clog('root-click:no-row', elInfo(event.target));
        }
      });

      root.addEventListener('change', function (event) {
        if (event.target.hasAttribute('data-rec-check') || event.target.hasAttribute('data-rec-qty') || event.target.hasAttribute('data-panel-qty')) {
          panel.updateTotal();
        }
      });

      root.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-option-name]');
        if (chip && panel.product) {
          panel.selected[chip.getAttribute('data-option-name')] = chip.getAttribute('data-option-value');
          panel.render();
          return;
        }
        if (event.target.hasAttribute('data-panel-qty-minus') && panel.qty) {
          panel.qty.value = Math.max(1, (parseInt(panel.qty.value, 10) || 1) - 1);
        }
        if (event.target.hasAttribute('data-panel-qty-plus') && panel.qty) {
          panel.qty.value = (parseInt(panel.qty.value, 10) || 1) + 1;
        }
        var recMinus = event.target.closest('[data-rec-minus]');
        var recPlus = event.target.closest('[data-rec-plus]');
        if (recMinus || recPlus) {
          var input = event.target.closest('.catalog-rec').querySelector('[data-rec-qty]');
          var next = (parseInt(input.value, 10) || 1) + (recPlus ? 1 : -1);
          input.value = Math.max(1, next);
          panel.updateTotal();
        }
        if (event.target.closest('[data-panel-manual]')) {
          panel.manual = true;
          panel.recsList.querySelectorAll('[data-rec-check]').forEach(function (input) {
            input.checked = false;
          });
          panel.updateTotal();
        }
        if (event.target.closest('[data-panel-atc]')) {
          addToCart(panel.currentItems(false), panel.atc).catch(function (error) {
            clog('panel-atc:fail', String(error && error.stack ? error.stack : error));
            alert((error && error.message) || getStrings().error || 'Error');
          });
        }
        if (event.target.closest('[data-panel-add-all]')) {
          addToCart(panel.currentItems(true), event.target.closest('[data-panel-add-all]')).catch(function (error) {
            clog('panel-add-all:fail', String(error && error.stack ? error.stack : error));
            alert((error && error.message) || getStrings().error || 'Error');
          });
        }
      });
    }

    function init() {
      var root = getRoot();
      clog('init', {
        hasRoot: !!root,
        bound: root && root.dataset.catalogBound,
        hasPanel: !!(root && root.querySelector('[data-catalog-panel]')),
        rowCount: root ? root.querySelectorAll('[data-catalog-row]').length : 0,
      });
      if (root) bind(root);
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, function (event) {
          if (event && event.responseText) storeProductsFromHtml(event.responseText);
        });
      }
      if (!document.documentElement.dataset.catalogDelegated) {
        document.documentElement.dataset.catalogDelegated = 'true';
        document.addEventListener(
          'click',
          function (event) {
            var rootEl = event.target.closest('[data-catalog-root]');
            if (!rootEl) return;
            var skip = event.target.closest('[data-catalog-close], button[data-catalog-view], [data-catalog-export], [data-option-name], [data-panel-atc], [data-panel-add-all], [data-panel-manual], [data-rec-minus], [data-rec-plus], [data-panel-qty-minus], [data-panel-qty-plus], [data-catalog-product-link]');
            var row = event.target.closest('[data-catalog-row]');
            clog('doc-capture-click', {
              target: elInfo(event.target),
              skip: elInfo(skip),
              row: elInfo(row),
              rootContainsRow: !!(row && rootEl.contains(row)),
            });
            if (skip) return;
            if (!row || !rootEl.contains(row)) return;
            openCatalogRow(rootEl, row);
          },
          true
        );
      }
    }

    document.addEventListener('click', function (event) {
      var atc = event.target.closest('[data-catalog-atc]');
      if (!atc) return;
      var root = getRoot();
      if (root && root.contains(atc)) return;
      event.preventDefault();
      var variantId = parseInt(atc.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      var original = atc.querySelector('span');
      addToCart([{ id: variantId, quantity: 1 }], atc)
        .then(function () {
          if (!original) return;
          var strings = getStrings();
          var prev = original.textContent;
          original.textContent = strings.added || 'Added';
          setTimeout(function () {
            original.textContent = prev;
          }, 1600);
        })
        .catch(function () {
          alert(getStrings().error || 'Error');
        });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('collection:rerendered', function () {
      var root = getRoot();
      var grid = document.getElementById('ProductGridContainer');
      var panel = root && root.querySelector('[data-catalog-panel]');
      clog('collection:rerendered', {
        hasRoot: !!root,
        bound: root && root.dataset.catalogBound,
        gridChildren: grid ? grid.children.length : null,
        gridPointer: grid ? grid.style.pointerEvents : null,
        panelExists: !!panel,
        panelInGrid: !!(grid && panel && grid.contains(panel)),
        productsData: !!document.getElementById('CatalogProductsData'),
        rowCount: root ? root.querySelectorAll('[data-catalog-table] [data-catalog-row]').length : 0,
      });
      if (!root) return;
      resetGridStyles();
      var fresh = parseJSON('CatalogProductsData', {});
      clog('collection:rerendered:products', {
        freshCount: fresh && typeof fresh === 'object' ? Object.keys(fresh).length : 0,
      });
      if (fresh && Object.keys(fresh).length) {
        root._catalogProducts = fresh;
      }
      bind(root);
      if (root._catalogPanel) {
        root._catalogPanel.refresh();
        root._catalogPanel.close();
      }
      setView(root, root.getAttribute('data-catalog-current-view') || 'table');
    });
  })();
